<template lang="pug">
.doc_descriptions
  .doc_content
    .main_title.d-flex.align-items-center(@click="expand()")
      img(:src="claimInfo.ClaimInfo_area02_Image")
      h4.i_ml_2 {{ claimInfo.ClaimInfo_area02_Title }}
      svg-icon(
        iconClass="arrow_bottom_g",
        className="arrow_bottom_g",
        :class="{ expand: isExpand }"
      )

    .items.flex-column.flex-md-row.i_mt_md_4(
      :class="{ expand: isExpand }",
      v-if="isExpand"
    )
      .prepare.flex-grow-1(
        v-if="checkDocList(claimInfo.ClaimInfo_area02_DocContent01, 1)"
      )
        h5 保戶準備
          li(
            v-for="(doc, index) in claimInfo.ClaimInfo_area02_DocContent01",
            v-if="doc.area02_DocContent01_Type == 1",
            :key="index"
          )
            a(
              v-if="doc.area02_DocContent01_FileURL",
              :href="doc.area02_DocContent01_FileURL",
              target="_blank"
            ) {{ doc.area02_DocContent01_Title }}
              svg-icon(iconClass="ic_download", className="icon")
            span(v-else) {{ doc.area02_DocContent01_Title }}
      .provide.flex-grow-1(
        v-if="checkDocList(claimInfo.ClaimInfo_area02_DocContent01, 2)"
      )
        h5 請對照協助提供
          li(
            v-for="(doc, index) in claimInfo.ClaimInfo_area02_DocContent01",
            v-if="doc.area02_DocContent01_Type == 2",
            :key="index"
          )
            a(
              :href="doc.area02_DocContent01_FileURL",
              v-if="doc.area02_DocContent01_FileURL",
              target="_blank"
            ) {{ doc.area02_DocContent01_Title }}
              svg-icon(iconClass="ic_download", className="icon")
            span(v-else) {{ doc.area02_DocContent01_Title }}
      .provide.flex-grow-1(
        v-if="checkDocList(claimInfo.ClaimInfo_area02_DocContent01, 3)"
      )
        h5 不指定
          li(
            v-for="(doc, index) in claimInfo.ClaimInfo_area02_DocContent01",
            v-if="doc.area02_DocContent01_Type == 3",
            :key="index"
          )
            a(
              :href="doc.area02_DocContent01_FileURL",
              v-if="doc.area02_DocContent01_FileURL",
              target="_blank"
            ) {{ doc.area02_DocContent01_Title }}
              svg-icon(iconClass="ic_download", className="icon")
            span(v-else) {{ doc.area02_DocContent01_Title }}
</template>

<script>
export default {
  name: "DocDescriptions",
  props: {
    claimInfo: Object,
  },
  data() {
    return {
      isExpand: false,
    };
  },
  methods: {
    expand() {
      this.isExpand = !this.isExpand;
    },
    checkDocList(docList, type) {
      for (let x in docList) {
        let doc = docList[x];
        if (type == doc.area02_DocContent01_Type) {
          return true;
        }
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/product/cliam_settlement_info/doc_descriptions";
</style>
